<template src="./template.html"/>
<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import Toggle from '@/components/elements/inputs/toggle';

export default {
  name: 'UserCard',
  components: {Btn, Popup, InputText, Toggle},
  props: {
    isEditable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      openPopup: false,
      file: null,
      form: {
        is_active: false,
        first_name: '',
        last_name: '',
        function: '',
        phone: ''
      }
    };
  },
  computed: {
    ...mapGetters([
      'get_stored_user',
      'get_language'
    ]),
  },
  created() {
    this.getComponentData()
  },
  methods: {
    uploadImage() {
      this.$refs.imageUploadInput.click();
    },
    imageSelected() {
      this.$store.dispatch('UPLOAD_USER_IMAGE', {
        id: this.get_stored_user.id,
        file: this.$refs.imageUploadInput.files[0],
      }).then(() => {
        this.$store.dispatch('GET_USER', {id: this.get_stored_user.id});
      });
    },
    getComponentData() {
      const userId = this.$route.params.id ? this.$route.params.id : localStorage.userId
      this.$store.dispatch('GET_USER', {id: userId});
    }
  },
  watch: {
    '$route' () {
      this.getComponentData()
    },
  },
}
</script>

